module.exports = __webpack_public_path__ + "img/03.44bd29ad.png";